import { ReactNode, ReactElement } from "react"

const resolveElements = (elements: ReactNode) => {
  if (!elements) return []
  return [...elements as ReactElement[]].filter(element => !!element)
}

export const findChildBy = (elements: ReactNode, blockName: string, propName: string): ReactNode[] =>
  resolveElements(elements).filter(element => element.props[propName] === blockName)
